import { LOAD_ACTIONS } from '../types/actionTypes';

const initialState = {
  currentLoad: null,
  isLoading: false,
  error: null
};

export const loadReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ACTIONS.FETCH_LOAD_REQUEST:
    case LOAD_ACTIONS.CREATE_LOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case LOAD_ACTIONS.FETCH_LOAD_SUCCESS:
    case LOAD_ACTIONS.CREATE_LOAD_SUCCESS:
      return {
        ...state,
        currentLoad: action.payload,
        isLoading: false,
        error: null
      };
    
    case LOAD_ACTIONS.FETCH_LOAD_FAILURE:
    case LOAD_ACTIONS.CREATE_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
}; 